<template lang="html">
  <v-app>
    <v-responsive>
      <detail-theme0001 v-if="theme === 1" :detail-product="detailproduct" />
    </v-responsive>
  </v-app>
</template>

<script>
import {
  getDetail as getDetailProduct,
  getDetailCombo as getDetailProductCombo
} from '@/api/product'
import detailTheme0001 from '@/views/menubook/themes/theme0001/Detail'
export default {
  components: {
    detailTheme0001
  },
  data() {
    return {
      theme: 1,
      detailproduct: {}
    }
  },
  created() {
    if (this.$route.params.product_type === 'product') {
      this.getDetail(this.$route.params.id)
    } else {
      this.getDetailCombo(this.$route.params.id)
    }
  },
  methods: {
    async getDetail(id) {
      try {
        const { data } = await getDetailProduct(id)
        this.$store.state.loading_axios = false
        this.detailproduct = data.data
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    async getDetailCombo(id) {
      try {
        const { data } = await getDetailProductCombo(id)
        this.$store.state.loading_axios = false
        this.detailproduct = data.data
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    }
  }
}
</script>
